export default "__VITE_ASSET__CpXG4gQ5__"